// src/hooks/useProductPageContent.js
import { useState } from "react";
import { getCompanyByAlphabet } from "../services/shopUserService";

const useCompanyByAlphabetList = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);

  const fetchCompanyByAlphabet = async (req) => {
    setStatus("loading");
    setError("");

    try {
      const response = await getCompanyByAlphabet(req);

      if (response?.status !== "Error") {
        // const _filteredData = response.data?.filter((item) => item.logo && item.businessName)
        setData(response.data); // depending on API shape
        setTotal(response.total ?? 0); // assuming total is part of the response
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const resetStatus = () => {
    setStatus("idle");
    setError("");
  };

  return {
    fetchCompanyByAlphabet,
    data,
    total,
    status,
    error,
    resetStatus,
  };
};

export default useCompanyByAlphabetList;
